export const filterArrData = (res: Array<any>, key: string, value: any, operator: string) => {
	let temp: Array<{}> = [];
	switch (operator) {
		case "=":
			for (let i = 0; i < res.length; i++) {
				if (res[i][key] && res[i][key] === value) {
					temp.push(res[i]);
				}
			}
			return temp;
		case "!":
			for (let i = 0; i < res.length; i++) {
				if ((res[i][key] && res[i][key] !== value) || !res[i][key]) {
					temp.push(res[i]);
				}
			}
			return temp;
		default:
			console.log("do nothing");
			break;
	}
	return temp;
};

export default filterArrData;
